import React from 'react';
import BlockContentArea from '@berlitz/blocks/lib/BlockContentArea';
import { SliceWrapper } from '../SliceWrapper';
import { getBackgroundColor, findSpansAndLinks, wrapParagraph} from '../../functions/utils';

const darkBackgrounds = ['#004FEF', 'purple', '#1D1D1D'];

const ModularBlockContentArea = ({ primary, pageLinks }) => {
  // Check if background color is dark
  const hasDarkBackground = darkBackgrounds.includes(getBackgroundColor(primary.section_background_color));
  const processedParagraphs = findSpansAndLinks(primary.content.raw, pageLinks);

  return (
    <SliceWrapper backgroundColor={getBackgroundColor(primary.section_background_color)} hasDarkBackground={hasDarkBackground}>
      <BlockContentArea
        innerHTML={wrapParagraph(processedParagraphs.map(p => p.text).join(''))}
        backgroundColor={getBackgroundColor(primary.section_background_color)}
        inverse={hasDarkBackground}
      />
    </SliceWrapper>
  );
};

export default ModularBlockContentArea;
